import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Preferences } from '@capacitor/preferences';

export const isNative = (): boolean => Capacitor.isNativePlatform();
export const getPlatform = (): string => Capacitor.getPlatform();

export async function getNetworkStatus() {
  return Network.getStatus();
}

export function onNetworkChange(callback: (connected: boolean) => void) {
  return Network.addListener('networkStatusChange', (status) => {
    callback(status.connected);
  });
}

export async function saveToOfflineQueue(key: string, data: unknown): Promise<void> {
  await Preferences.set({ key, value: JSON.stringify(data) });
}

export async function getOfflineQueue<T>(key: string): Promise<T | null> {
  const { value } = await Preferences.get({ key });
  return value ? (JSON.parse(value) as T) : null;
}

export async function writeAudioFile(filename: string, base64Data: string) {
  return Filesystem.writeFile({
    path: filename,
    data: base64Data,
    directory: Directory.Cache,
  });
}
